import axiosInstance from 'api/base';
import { normalizeRedirectLink } from 'utils/commonNormalizer';
import { prepareFormData } from 'utils/form';
import { IRedirectLinkResponse } from 'utils/types';

import { normalizeRuleset } from './normalizers';
import { IManualTransactionForm, IRuleset } from './types';

const motoAPI = {
  async getAvailableRulesets(payload: IManualTransactionForm): Promise<IRuleset[]> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.post(
      'transactions/available-rulesets',
      normalizedPayload,
    );

    return response?.data?.result.map(normalizeRuleset) || [];
  },

  async createManualTransaction(
    payload: IManualTransactionForm,
  ): Promise<IRedirectLinkResponse> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.post('transactions', normalizedPayload);

    return normalizeRedirectLink(response.data);
  },
};

export default motoAPI;
